import jszip from 'jszip';
export const isFileValid = async (file: File) => {
  const fileExt = file.name.split('.').pop()?.toLowerCase();
  if (fileExt === 'pdf') {
    return new Promise<boolean>((resolve) => {
      const reader = new FileReader();
      reader.onerror = () => resolve(false);
      reader.readAsArrayBuffer(file);
      reader.onload = async function () {
        const files = new Blob([file], { type: 'application/pdf' });
        const text = await files.text();
        const isEncrypted =
          text.includes('Encrypt') ||
          text
            .substring(text.lastIndexOf('<<'), text.lastIndexOf('>>'))
            .includes('/Encrypt');
        if (isEncrypted) {
          resolve(false);
        } else {
          resolve(true);
        }
      };
    });
  } else if (fileExt === 'docx' || fileExt === 'doc') {
    return new Promise(async (resolve, reject) => {
      try {
        const zip = await jszip.loadAsync(file);
        const hasMacros = !!Object.keys(zip.files).find((f) =>
          f.includes('vbaProject'),
        );
        resolve(!hasMacros);
      } catch {
        resolve(false);
      }
    });
  }
  return true;
};
